import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

interface RevokeSessionsModalProps {
  user: {
    id: number;
    name: string;
    email: string | null;
    role: string;
  } | null;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RevokeSessionsModal({
  user,
  isOpen,
  isSubmitting,
  onClose,
  onConfirm,
}: RevokeSessionsModalProps) {
  if (!user) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <LogOut className="h-4 w-4" />
            Sign Out Devices
          </DialogTitle>
          <DialogDescription>
            Sign <strong>{user.name}</strong> out of all mobile devices and revoke their active
            sessions.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-900">
            <p>
              They can sign back in immediately with their existing credentials. This does not
              archive or delete their account.
            </p>
          </div>
          <div className="text-sm text-muted-foreground">
            <p>
              <strong>Email:</strong> {user.email || "No email"}
            </p>
            <p>
              <strong>Role:</strong> {user.role}
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isSubmitting}>
            {isSubmitting ? "Signing out…" : "Sign Out Devices"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
